import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const createProfile = createAsyncThunk(
  "api/fetchData",
  async ({ userData, uid }) => {
    let config = {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
        "Content-Type": "application/json",
      },
    };

    try {
      const response = await axios.post(
        `${API_BASE_URL}/user?organisationId=${uid}`,

        userData,
        config
      );
      let status = "success";
      let data_res = {
        status: status,
        message: response,
      };
      return data_res;
    } catch (error) {
      let status = "error";
      let data_error = {
        status: status,
        message:
          error.response?.data || "Something went wrong, please try again.",
      };
      return data_error;
    }
  }
);

const createProfileSlice = createSlice({
  name: "api",
  initialState: {
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createProfile.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default createProfileSlice.reducer;
